export default __webpack_public_path__ + "static/media/download-alert.4232f3bc.svg";